module.exports = __webpack_public_path__ + "media/images/brand/banner/spot_art@2x-15a035bd8949599b1f7eee9c3fed4dd3.png";